module.exports = __webpack_public_path__ + "static/img/solution-lesssound.3a96974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solutions/solution-lesssound.png
// module id = K8eB
// module chunks = 0